import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_CAN_ADD_SIGNATURE,
    CLEAR_CAN_ADD_SIGNATURE_ERROR,
    LOAD_CAN_ADD_SIGNATURE_REQUEST,
    LOAD_CAN_ADD_SIGNATURE_SUCCESS,
    LOAD_CAN_ADD_SIGNATURE_FAILURE,
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_CAN_ADD_SIGNATURE,
    CLEAR_ERROR: CLEAR_CAN_ADD_SIGNATURE_ERROR,
    LOAD_REQUEST: LOAD_CAN_ADD_SIGNATURE_REQUEST,
    LOAD_SUCCESS: LOAD_CAN_ADD_SIGNATURE_SUCCESS,
    LOAD_FAILURE: LOAD_CAN_ADD_SIGNATURE_FAILURE
}